'use strict';

angular.module('ntmApp').factory('ListGridPreferences', ['ListGridStatus', 'GridService',
    function (ListGridStatus, GridService) {

    function ListGridPreferences(preferences) {

        var self = this;

        self.isColumnVisible = function (columnName) {
            return preferences[columnName] !== false;
        };

        self.changePreferences = function (columnDefs) {
            var columnList = {};

            columnDefs.forEach(function (item) {
                columnList[item.name] = item.visible;
            });

            GridService.SavePreferences({
                id: ListGridStatus.gridId,
                json: JSON.stringify(columnList)
            });
        };
    }

    return (ListGridPreferences);
}]);